import {
  CONFIG_TYPES,
  SYNC_DIRECTION,
} from '../../constants/integrationConstants/crmConstants';

// eslint-disable-next-line import/prefer-default-export
export const getSideNavBarInfo = (sideNavBar) => {
  const [criteria, syncDirection] = sideNavBar.split('-');
  return { criteria, syncDirection };
};

export const getSideNavBarChangeLocation = (
  sideNavBarTab,
  entityTab,
  recentEntityTab
) => {
  if (sideNavBarTab === CONFIG_TYPES.DEDUPLICATION) {
    return {
      entityTab: entityTab || recentEntityTab,
      sideNavBarTab,
      syncDirection: null,
      stepBuilderTab: 0,
      currentConfigType: CONFIG_TYPES.DEDUPLICATION,
    };
  }
  if (sideNavBarTab === CONFIG_TYPES.PARENT_LINK) {
    return {
      entityTab: entityTab || recentEntityTab,
      sideNavBarTab,
      syncDirection: SYNC_DIRECTION.IN,
      stepBuilderTab: 0,
      currentConfigType: CONFIG_TYPES.PARENT_LINK,
    };
  }
  return {
    entityTab: entityTab || recentEntityTab,
    sideNavBarTab,
    syncDirection: SYNC_DIRECTION.IN,
    stepBuilderTab: 0,
    currentConfigType: CONFIG_TYPES.IN_SYNC,
  };
};
